import Keyb from "keyb"
import Joyp from "joyp"
import Pointer from "poin"
import Screenfull from "screenfull"

import Game from "@fae/source/models/Game.js"
import Sequence from "@fae/source/models/Sequence.js"

import Navigation from "@fae/source/engine/navigating/Navigation.js"
import SequenceAnimation from "@fae/source/engine/animating/SequenceAnimation.js"
import Audiomix from "@fae/source/engine/Audiomix.js"
import Dev from "@fae/source/models/dev/Dev.js"

import navigation from "@fae/source/data/navigation.js" // eslint-disable-line no-unused-vars
import app from "@fae/source/data/app.js"

export default new class App {
    constructor() {
        window.fae = window.fae || {}
        window.fae.app = this

        this.defaultGameSlug = app.defaultGameSlug

        this.options = {}
    }
    update(delta) {
        if(Keyb.isPressed("<control>")
        && Keyb.isPressed("Q")) {
            Navigation.go("/title")
        }

        if(Keyb.isPressed("<shift>")
        && Keyb.wasJustPressed("F")) {
            Screenfull.toggle()
        }

        if(this.game?.chapter?.stage?.update instanceof Function) {
            this.game.chapter.stage.update(delta)
        }

        // if(Dev.isEnabled) {
        //     if(Keyb.wasJustPressed("1")) {
        //         this.options.disableActionUI = !this.options.disableActionUI
        //         console.log("action cursor", this.options.disableActionUI ? "disabled" : "enabled")
        //     }
        //     if(Keyb.wasJustPressed("2")) {
        //         this.options.disableHUD = !this.options.disableHUD
        //         console.log("hud", this.options.disableHUD ? "disabled" : "enabled")
        //     }
        //     if(Keyb.wasJustPressed("3")) {
        //         this.options.disableParticles = !this.options.disableParticles
        //         console.log("particles", this.options.disableParticles ? "disabled" : "enabled")
        //     }
        //
        //     if(Keyb.wasJustPressed("4")) {
        //         if(Audiomix.userMusicVolume > 0) {
        //             Audiomix.userMusicVolume = 0
        //             Audiomix.userAmbienceVolume = 0
        //             console.log("music disabled")
        //         } else {
        //             Audiomix.userMusicVolume = 1
        //             Audiomix.userAmbienceVolume = 1
        //             console.log("music enabled")
        //         }
        //     }
        // }

        if(Navigation.state != undefined) {
            if(Navigation.state.screenKey == "ChapterScreen") {
                if(Dev.inProtoMode == true) {
                    Navigation.state.escape = undefined
                }
                if(Dev.inProtoMode == false
                && Keyb.wasJustPressed("<escape>", delta.ms)) {
                    if(window.isBookOpen == true) {
                        window.isBookOpen = false // book
                    } else if(Navigation.state.escape == undefined) {
                        Navigation.state.escape = {"section": "MainSection"}
                    } else if(Navigation.state.escape != undefined) {
                        if(Navigation.state.escape.section == "MainSection") {
                            Navigation.state.escape = undefined
                        } else if(Navigation.state.escape.section == "OptionsSection") {
                            Navigation.state.escape.section = "MainSection"
                        }
                    }
                }

                if(Navigation.state.escape != undefined) {
                    return // paused!!
                }
            }
        }

        if(this.game != undefined
        && this.game.chapter != undefined) {
            this.game.chapter.selection.update(delta)

            const stage = this.getActiveStage()
            if(stage?.turn.affiliation === "good") {
                if(stage.player.timeout - this.game.chapter.timer > 0) {
                    this.game.chapter.timer += Math.min(delta.ms, 100)
                    if(stage.player.timeout - this.game.chapter.timer <= 0) {
                        this.endPlayerTurn()
                    }
                    // console.log(stage.phase)
                    if(stage.player.phase == "ritual"
                    && Audiomix.getActiveTriggerByLabel("music")?.key != "Music:4") {
                        Audiomix.trigger("Music:4")
                    }
                    if(stage.player.phase == "observe"
                    && Audiomix.getActiveTriggerByLabel("music")?.key != "Music:1") {
                        Audiomix.trigger("Music:1")
                    }
                }
            }

            if(Keyb.isPressed("<control>") && Keyb.isPressed("R")) {
                this.game.chapter.restart()
            }

            if(Dev.inProtoMode == false) {
                if(Keyb.wasJustPressed("Z")
                || Joyp.wasJustPressed(0, "left-bumper", delta.ms)
                || Joyp.wasJustPressed(0, "right-bumper", delta.ms)) {
                    this.game.chapter.actionTrace.push({"type": "undoAction"})
                    this.game.chapter.undoAction()
                    Dev.recordSavestate("livePlaytest")
                }
            }
        }

        if(this.previewChapter != undefined) {
            // this.previewChapter.update(delta)

            const SLOWDOWN = 1 // 0.66
            SequenceAnimation.updateSequence({
                "sequence": this.previewChapter.animationSequence,
                "delta": {
                    "ms": delta.ms * SLOWDOWN,
                    "f": delta.f * SLOWDOWN,
                    "s": delta.s * SLOWDOWN,
                },
                "isMuted": true,
            })
        }

        if(Dev.inProtoMode != true
        && this.sequence != undefined) {
            SequenceAnimation.updateSequence({
                "sequence": this.sequence,
                "delta": delta,
            })

            if(Pointer.wasJustPressed("primary", true, delta.ms)
            || Keyb.wasJustPressed("<space>", delta.ms)
            || Joyp.wasJustPressed(0, "south-button", delta.ms)) {
                Sequence.seek(this.sequence)
            }
        }
    }
    load(app) {
        this.game = Game.load(app.game)
    }
    getActiveStage() {
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].stage != undefined) {
            // console.log("App.sequence")
            return this.sequence.steps[0].stage
        }
        if(this.game != undefined
        && this.sequence != undefined
        && this.sequence.steps != undefined
        && this.sequence.steps[0] != undefined
        && this.sequence.steps[0].omegastage != undefined) {
            // console.log("App.sequence's omegastage")
            return this.sequence.steps[0].omegastage
        }
        if(this.game != undefined
        && this.game.chapter != undefined) {
            // console.log("App.game.chapter.stage")
            return this.game.chapter.stage
        }
        // chapter.animationSequence
    }
}
